'use strict';

import React from 'react';
import moment from "moment-timezone";
import Week from "./Week/Week";
import { GetAvailability } from '../../../actions/availabilityActions';
import { OnSchedUtils } from '../../../utils';

const WeekCalendar = ({ element, date, initialDate, selectDate, availability, timezoneName, setDate, setAvailability }) => {
  const [disabledDates, setDisabledDates] = React.useState([]);
  const [calendarStartDate, setCalendarStartDate] = React.useState(moment(date).format('YYYY-MM-DD'));
  const [weeks, setNoWeeks] = React.useState([moment(calendarStartDate).format('YYYY-MM-DD')]);
  const [currentWeekNo, setCurrentWeekNo] = React.useState(0);

  const dayDisabled = (dayNo, weekNo) => 
    disabledDates.includes(moment(calendarStartDate)
                        .add(weekNo, 'weeks')
                        .startOf('week')
                        .add(dayNo, 'days')
                        .format('YYYY-MM-DD'))

  const navigateWeek = () => {
    setNoWeeks(weeks.concat(moment(weeks[weeks.length - 1]).add(1, 'week').format('YYYY-MM-DD')))
  }

  const nextWeek = () => {
    navigateWeek();
    setCurrentWeekNo(currentWeekNo + 1);

    let nextWeekDayIdx = 0;
    
    while (dayDisabled(nextWeekDayIdx, currentWeekNo)) {
      nextWeekDayIdx++;
    }

    const selectedDate = moment(calendarStartDate)
      .add((currentWeekNo + 1), 'weeks')
      .startOf('week')
      .add(nextWeekDayIdx, 'days')
      .format('YYYY-MM-DD');

    OnSchedUtils.Loading(element, true, 'Availability');
    
    GetAvailability(element, selectedDate, timezoneName)
      .then(response => {
        setAvailability(response);
        setDate(selectedDate);
        OnSchedUtils.Loading(element, false);
      })

    const slidesContainer = document.getElementById("slides-container");
    const slide = document.querySelector(".Week");
    
    const slideWidth = slide.clientWidth;
    slidesContainer.scrollLeft += slideWidth;
  }
  
  const prevWeek = () => {
    if (currentWeekNo) {
      setCurrentWeekNo(currentWeekNo - 1);
  
      let nextWeekDayIdx = 0;
      
      while (dayDisabled(nextWeekDayIdx, currentWeekNo)) {
        nextWeekDayIdx++;
      }

      const selectedDate = moment(calendarStartDate)
        .add((currentWeekNo - 1), 'weeks')
        .startOf('week')
        .add(nextWeekDayIdx, 'days')
        .format('YYYY-MM-DD');

      OnSchedUtils.Loading(element, true, 'Availability');
      
      GetAvailability(element, selectedDate, timezoneName)
        .then(response => {
          const firstAvailable = OnSchedUtils.FirstAvailableInWeek(selectedDate, response);
          const dateToSet = firstAvailable ? firstAvailable : selectedDate;
          
          setAvailability(response);
          setDate(dateToSet);
          OnSchedUtils.Loading(element, false);
        })
    }

    const slidesContainer = document.getElementById("slides-container");
    const slide = document.querySelector(".Week");
    
    const slideWidth = slide.clientWidth;
    slidesContainer.scrollLeft -= slideWidth;
  }

  React.useEffect(() => {
    if (date) {
      setCalendarStartDate(date)
    }
  }, [])
  
  React.useEffect(() => {
    if (availability) {
      if (availability.availableDays) {
        const disable = availability.availableDays.filter(d => !d.available).map(d => d.date);
        
        setDisabledDates(disable);
      }
    }
  }, [availability])

  React.useEffect(() => {
    const checkWeekForAllDisabled = weekNo => {
      const weekDisabledArr = [
        dayDisabled(0, weekNo),
        dayDisabled(1, weekNo),
        dayDisabled(2, weekNo),
        dayDisabled(3, weekNo),
        dayDisabled(4, weekNo),
        dayDisabled(5, weekNo),
        dayDisabled(6, weekNo)
      ]
      
      return !weekDisabledArr.includes(false)
    }

    if (disabledDates?.length) {
      let weekIdx = 0;
      while (checkWeekForAllDisabled(weekIdx)) {
        navigateWeek();
        setCurrentWeekNo(currentWeekNo + 1);
        const slidesContainer = document.getElementById("slides-container");
        const slide = document.querySelector(".Week");
            
        const slideWidth = slide.clientWidth;
        slidesContainer.scrollLeft += slideWidth;
        
        weekIdx++;
      };
      
      let dayIdx = 0;

      while (dayDisabled(dayIdx, weekIdx)) {
        dayIdx++;
      }

      // selectDate(moment(calendarStartDate)
      //   .add(weekIdx, 'weeks')
      //   .startOf('week')
      //   .add(dayIdx, 'days')
      //   .format('YYYY-MM-DD'))
    }

  }, [disabledDates])
  
  return (
    <section className="slider-wrapper">
      <button onClick={prevWeek} className="slide-arrow" id="slide-arrow-prev">
        &#8249;
      </button>
      <button onClick={nextWeek} className="slide-arrow" id="slide-arrow-next">
        &#8250;
      </button>
      <ul className="slides-container" id="slides-container">
        <Week element={element} date={date} week={moment(calendarStartDate)} disabledDates={disabledDates} timezoneName={timezoneName} setDate={setDate} setAvailability={setAvailability} />

        {weeks.map(
          (w, i) => (<Week key={i} element={element} date={date} week={moment(calendarStartDate).add((i + 1), 'week')} disabledDates={disabledDates} timezoneName={timezoneName} setDate={setDate} setAvailability={setAvailability} />)
          )
        }
      </ul>
    </section>
  )
}

export default WeekCalendar
